<template>
  <div>
    <v-row no-gutters align="center" class="pt-4" justify="space-between">
      <v-col cols="12" md="4">
          <title-page
            title="List Bank Data"
            :back="true"
            colorIconBack="#006341"
          />

      </v-col>
      <v-col cols="12" md="4">
        <div class=" d-flex align-center justify-end">
          <v-btn depressed color="var(--g)" @click="exportData" dark
            >Export</v-btn
          >
        </div>
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="mb-1"
        v-if="
          permissions.includes('UPCM') ||
          role == 'SUPERADMIN'
        "
      >
        <v-row justify="end" no-gutters>
          <v-col cols="12" md="6" class="mb-1 d-flex justify-end">
            <v-btn color="#006341" to="/bank-data/add-data">
              <v-icon left color="white"> mdi-account-plus </v-icon>
              <h4 style="color: white">Add Data</h4>
            </v-btn>
          </v-col>
          <v-col cols="12" md="6" class="mb-1 d-flex justify-end">
            <v-btn color="#006341" to="/bank-data/add-multiple-data">
              <v-icon left color="white"> mdi-account-multiple-plus </v-icon>
              <h4 style="color: white">Add Multiple Data</h4>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-card class="rounded_max mt-5" flat>
      <div class="pa-3">
        <v-card flat class="rounded-lg" color="#f6f6f6">
          <v-row no-gutters>
            <v-col cols="12" md="5">
              <div class="pa-2">
                <v-text-field
                  placeholder="Search Scholar"
                  solo
                  v-model="find"
                  @keyup="fetchData"
                  hide-details
                  dense
                  prepend-inner-icon="mdi-magnify"
                  flat
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" md="2">
              <div class="pa-2">
                <v-select
                  dense
                  hide-details
                  :items="optSort"
                  item-text="txt"
                  item-value="val"
                  v-model="sort"
                  @change="fetchData()"
                  placeholder="Sort"
                  flat
                  solo
                ></v-select>
              </div>
            </v-col>
            <v-col cols="12" md="2">
              <div class="pa-2">
                <v-menu
                  v-model="menuLimit"
                  bottom
                  :nudge-bottom="55"
                  elevation="0"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      class="text-capitalize color_txt"
                      height="38px"
                      block
                      color="#fff"
                      v-bind="attrs"
                      v-on="on"
                      ><p class="default_txt">Show : {{ limit }}</p>
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-card class="popup_radius" outlined elevation="0">
                    <v-list>
                      <v-list-item link @click="changeLimit(10)">
                        <v-list-item-title>10</v-list-item-title>
                      </v-list-item>
                      <v-list-item link @click="changeLimit(50)">
                        <v-list-item-title>50</v-list-item-title>
                      </v-list-item>
                      <v-list-item link @click="changeLimit(100)">
                        <v-list-item-title>100</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <!--  ========================================================================= data table -->
      <div>
        <v-skeleton-loader
          type="table-tbody"
          v-if="loading"
        ></v-skeleton-loader>
        <div v-if="dataSet && !loading">
          <v-data-table
            :headers="headers"
            :items="dataSet"
            :page.sync="page"
            :items-per-page="limit"
            class="elevation-0 color_txt"
            hide-default-footer
            :single-select="false"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      fab
                      depressed
                      x-small
                      class="mr-2"
                      color="blue"
                      dark
                      @click="updateBankData(item)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit Data</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      fab
                      v-bind="attrs"
                      v-on="on"
                      depressed
                      x-small
                      color="red"
                      @click="deleteBankData(item)"
                      :disabled="
                        role != 'SCHOLAR'
                          ? false
                          : true
                      "
                    >
                      <v-icon color="white">mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete Data</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </div>
      </div>
      <div class="text-center pa-3" v-if="dataSet">
        <v-pagination
          v-model="page"
          color="#006341"
          @input="fetchData"
          :length="last_page"
        ></v-pagination>
      </div>
    </v-card>
    <div class="pa-2">
      <dialog-small
        :d_small="d_small"
        @refetch="fetchData"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TitlePage from "../../components/atom/titlePage.vue";
import DialogSmall from "../dialog/dialogSmall.vue";
export default {
  name: "listBankData",
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  components: { TitlePage, DialogSmall },
  data() {
    return {
      loading: false,
      d_small: false,
      d_type: "",
      d_title: "",
      find: "",
      dataSet: null,
      page: 1,
      limit: 10,
      total: null,
      last_page: null,
      sort: "",
      inventory: "",
      menuLimit: false,
      optUniv: [],
      optSort: [
        { txt: "Newest", val: "-created_at" },
        { txt: "Oldest", val: "created_at" },
        { txt: "All", val: "" },
      ],
      headers: [
        {
          text: "ID",
          align: "start",
          value: "id",
        },
        {
          text: "Name Scholar",
          align: "start",
          value: "name",
        },
        {
          text: "Email",
          align: "start",
          value: "email",
        },
        {
          text: "University",
          align: "start",
          value: "university.name",
        },
        {
          text: "Major",
          align: "start",
          value: "major",
        },
        { text: "Actions", sortable: false, value: "actions" },
      ],
    };
  },
  async mounted() {
    this.dataUniv();
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/bank-data?page[number]=${this.page}&page[size]=${this.limit}&filter[search]=${this.find}&sort=${this.sort}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.total = data.total;
          this.last_page = data.last_page;
          this.changeUniv(data.data);
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    dataUniv() {
      let data = {
        path: `manage/univ/get`,
      };
      this.$store.dispatch("user/getUser", data).then((data) => {
        this.optUniv = data.data;
      });
    },
    async changeUniv(item) {
      await item.forEach((item) => {
        item.university = { id: item.university, name: null };
        for (let i = 0; i < this.optUniv.length; i++) {
          if (item.university.id == this.optUniv[i].id) {
            item.university.name = this.optUniv[i].name;
          }
        }
      });
      this.dataSet = item;
      this.loading = false;
    },
    changeLimit(val) {
      this.limit = val;
      this.fetchData();
    },
    updateBankData(item) {
      this.$router.push(`/bank-data/update-data/${item.id}`);
    },
    deleteBankData(item) {
      this.d_type = "d_bankData";
      this.d_title = "Delete Data";
      this.d_small = true;
      item["d_width"] = "300px";
      this.inventory = item;
    },
    exportData() {
      let data = {
        path: `manage/bank-data/export`,
        body: {
          "filter[tsa_id]": this.univ,
          "filter[tsa_category_id]": this.type,
          "filter[search]": this.find,
        },
      };
      this.$store.dispatch("exportData", data);
    },
  },
};
</script>

<style></style>
